const raffle = {
  // 全部游戏通行证 ---- 范昂
  pageAllPasses: `/authApi/pass/v1/pageAllPasses`,
  // 我的通行证 ---- 范昂
  pageMyPasses: `/authApi/pass/v1/pageMyPasses`,
  // 查询用户是否激活过此游戏通行证 ---- 范昂
  queryUserGameActivatedPassFlag: `/authApi/pass/v1/queryUserGameActivatedPassFlag`,
  // 游戏通行证默认奖励 ---- 范昂
  listPassGroupPrizeTop: `/authApi/pass/v1/listPassGroupPrizeTop`,
  // 我的通行证-游戏下通行证 ---- 范昂
  pageMyGamePasses: `/authApi/pass/v1/pageMyGamePasses`,
  // 查询用户通行证信息 ---- 范昂
  queryUserGamePass: `/authApi/pass/v1/queryUserGamePass`,
  // 通行证每日任务 ---- 范昂
  listPassTask: `/authApi/pass/v1/listPassTask`,
  // 通行证说明查询 ---- 范昂
  queryPassMessage: `/authApi/pass/v1/queryPassMessage`,
  // 通行证规则查询 ---- 范昂
  queryPassRule: `/authApi/pass/v1/queryPassRule`,
  // 查询用户通行证奖励列表 ---- 范昂
  listUserGamePassPrizes: `/authApi/pass/v1/listUserGamePassPrizes`,
  // 查询用户通行证奖励列表 ---- 范昂
  listUserGamePassPrizesV2: `/authApi/pass/v2/listUserGamePassPrizes`,
  // 查询用户通行证奖励列表 ---- 范昂
  receiveUserGamePassPrizes: `/authApi/pass/v1/receiveUserGamePassPrizes`,
  // 获取游戏主区服信息 ---- 李健
  gameMainServerList: `/authApi/pass/v1/gameMainServerList`,
  // 获取主区服下面的区服信息 ---- 李健
  gameServerList: `/authApi/pass/v1/gameServerList`,
  // 通过游戏和区服获取角色信息 ---- 李健
  gameRole: `/authApi/pass/v1/gameRole`,
  // 查询角色是否激活过通行证 ---- 范昂
  queryGameRoleActivatedPassFlag: `/authApi/pass/v1/queryGameRoleActivatedPassFlag`,
  // 用户激活通行证 ---- 范昂
  userActivatePass: `/authApi/pass/v1/userActivatePass`,
  // 创建订单 ---- 李健
  createOrder: `/authApi/pass/create/order`,
  // 创建支付单并获取支付报文 ---- 李健
  tradePay: `/authApi/pass/create/trade/pay`,
  // 获取通行证支付状态 ---- 李健
  payStatus: `/authApi/pass/pay/status`,
  // 查询用户游戏角色列表 ---- 范昂
  listUserGameRole: `/authApi/pass/v1/listUserGameRole`
};

export default raffle;
